const SelfAssessmentActionType = {
  GET_SELF_ASSESSMENTS: 'GET_SELF_ASSESSMENTS',
  SAVE_SELF_ASSESSMENTS: 'SAVE_SELF_ASSESSMENTS',
  RESET_SELF_ASSESSMENTS: 'RESET_SELF_ASSESSMENTS',
  GENERATE_SELF_ASSESSMENTS_REPORT: 'GENERATE_SELF_ASSESSMENTS_REPORT',
};

export default SelfAssessmentActionType;
